var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeader3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 224,
    height: 26,
    viewBox: "0 0 224 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_62674",
    "data-name": "Group 62674",
    transform: "translate(-86 -368.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16381",
    "data-name": "Rectangle 16381",
    transform: "translate(86 368.57)",
    fill: "#393939",
    stroke: "#d3d3d3",
    strokeMiterlimit: 10,
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 26,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.35,
    width: 223.3,
    height: 25.3,
    rx: 1.65,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Legal_Counsel_Appointment",
    "data-name": "Legal Counsel Appointment",
    transform: "translate(95 383)",
    fill: "#fff",
    fontSize: 6,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Legal Counsel Appointment")), /*#__PURE__*/React.createElement("g", {
    id: "Group_60127",
    "data-name": "Group 60127",
    transform: "translate(-966 -42)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55646",
    "data-name": "Group 55646",
    transform: "translate(-37.688 402.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53006",
    "data-name": "Path 53006",
    d: "M14.375,8.688A5.688,5.688,0,1,1,8.688,3a5.687,5.687,0,0,1,5.688,5.688Z",
    transform: "translate(1289 13)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53007",
    "data-name": "Path 53007",
    d: "M13.635,11.631a1.619,1.619,0,0,1,1.809-1.114A1.683,1.683,0,0,1,16.795,12.2c0,1.136-1.626,1.7-1.626,1.7",
    transform: "translate(1282.318 8.224)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2510",
    "data-name": "Ellipse 2510",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(1259.5 425.695)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_55648",
    "data-name": "Group 55648",
    transform: "translate(-976 1115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53004",
    "data-name": "Path 53004",
    d: "M12.835,5.779A3.1,3.1,0,0,0,9.5,3,3.1,3.1,0,0,0,6.167,5.779C6.167,9.021,4.5,9.948,4.5,9.948h10s-1.667-.926-1.667-4.169",
    transform: "translate(1237.5 -741)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53005",
    "data-name": "Path 53005",
    d: "M18.288,31.5a1.667,1.667,0,0,1-2.883,0",
    transform: "translate(1230.154 -760.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeader3);
export default __webpack_public_path__ + "static/media/header3.7206be1306262cd49ea3e6e39c6c1f9f.svg";
export { ForwardRef as ReactComponent };